import React, { Component } from 'react'

import Navigation from '../Navigation/Navigation';

class Careers extends Component {
  render() {
    return (
      <section id="careers">
        <Navigation></Navigation>
        <div className="content is-center">
          <h1 className="coming-soon">Cooming Soon...</h1>
          <p>Careers</p>
        </div>
      </section>
    )
  }
}

export default Careers
